/**
 * OutcomeUpliftBars.jsx — Thin re-export from locked primitive
 *
 * GRANULLO_SIGNATURE_GRAPH_PERMANENT_SOURCE_LOCK
 *
 * This file is a passthrough to the locked primitive:
 *   /components/primitives/SignatureProofGraphLocked.jsx
 *
 * DO NOT add any graph logic here.
 * DO NOT override, wrap, or restyle the primitive.
 * All graph geometry, hatch logic, and spacing live in the locked primitive.
 *
 * Source: commit d07c8fab4
 * Authority: FOUNDER
 */
import SignatureProofGraphLocked from '../primitives/SignatureProofGraphLocked';

export default SignatureProofGraphLocked;
